module.exports = __webpack_public_path__ + "img/3.b1808506.svg";